import { global } from ":global";
import type { ApiResponse } from "./_model";

export async function removeTeamMember(props: { id: number }) {
  return global.api.getAuth(`/teaming/remove-member/${props.id}/`).then((res) => {
    return res.data;
  });
}
